import { createI18n } from 'vue-i18n';
import en from './locales/en.json';
import zh from './locales/zh.json';

const messages = {
  en,
  zh
};

const i18n = createI18n({
  legacy: false,
  locale: localStorage.getItem('lang') || 'en', // 这里读取本地存储
  fallbackLocale: 'en',
  messages: { en, zh }
})

export default i18n;